var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-group',{attrs:{"label":"技","description":"ダイスショットで使用する技。成功するとダイス値に選択したステータスが加算されます。"}},[_c('b-form-select',{attrs:{"options":[
        { value:'STR', text:'【STR】力押し' },
        { value:'INT', text:'【INT】頭を使う' },
        { value:'VIT', text:'【VIT】我慢する' },
        { value:'MND', text:'【MND】説得する' },
        { value:'DEX', text:'【DEX】急所を狙う' },
        { value:'AGI', text:'【AGI】うまいことやる' } ]},on:{"input":function($event){return _vm.$emit('input', _vm.form)}},model:{value:(_vm.form.use),callback:function ($$v) {_vm.$set(_vm.form, "use", $$v)},expression:"form.use"}})],1),_c('b-form-group',{attrs:{"label":"見切り","description":"ダイスショットで封殺する技。相手の技に一致すると失敗させることができます。"}},[_c('b-form-select',{attrs:{"options":[
        { value:'STR', text:'【STR】力押し' },
        { value:'INT', text:'【INT】頭を使う' },
        { value:'VIT', text:'【VIT】我慢する' },
        { value:'MND', text:'【MND】説得する' },
        { value:'DEX', text:'【DEX】急所を狙う' },
        { value:'AGI', text:'【AGI】うまいことやる' } ]},on:{"input":function($event){return _vm.$emit('input', _vm.form)}},model:{value:(_vm.form.block),callback:function ($$v) {_vm.$set(_vm.form, "block", $$v)},expression:"form.block"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }